import type { Tone } from "@brutally/shared";

export interface LoadingLevel {
  lvl: string;
  line: string;
}

export const GAME_LOADING: LoadingLevel[] = [
  { lvl: "LEVEL 1", line: "Reading your site the way a cold stranger would." },
  { lvl: "LEVEL 2", line: "Checking if the buyer would actually pay." },
  { lvl: "LEVEL 3", line: "Cross-examining your claim against your homepage." },
  { lvl: "LEVEL 4", line: "Letting the skeptic poke holes in it." },
  { lvl: "LEVEL 5", line: "Seeing if search engines can even find you." },
  { lvl: "LEVEL 6", line: "Asking if AI search would ever recommend you." },
  { lvl: "LEVEL 7", line: "Counting the seconds before someone bounces." },
  { lvl: "BOSS", line: "Tallying up the damage." }
];

export interface Judge {
  name: string;
  tone: Tone;
}

export const JUDGES: Judge[] = [
  { name: "The Visitor", tone: "red" },
  { name: "The Buyer", tone: "yellow" },
  { name: "The Skeptic", tone: "blue" },
  { name: "Search Engines", tone: "green" },
  { name: "AI Search", tone: "purple" },
  { name: "Your Numbers", tone: "red" }
];

export const QUEST_POINTS: number[] = [9, 8, 6, 7, 5, 4, 5];

export interface Grade {
  letter: "F" | "D" | "C" | "B" | "A" | "S";
  tone: Tone;
  bg: string;
  fg: string;
}

export function gradeFor(score: number): Grade {
  if (score < 25) return { letter: "F", tone: "red", bg: "var(--red)", fg: "#fff" };
  if (score < 45) return { letter: "D", tone: "red", bg: "var(--red)", fg: "#fff" };
  if (score < 60) return { letter: "C", tone: "yellow", bg: "var(--yellow)", fg: "var(--ink)" };
  if (score < 75) return { letter: "B", tone: "blue", bg: "var(--blue)", fg: "#fff" };
  if (score < 90) return { letter: "A", tone: "green", bg: "var(--green)", fg: "#fff" };
  return { letter: "S", tone: "green", bg: "var(--green)", fg: "#fff" };
}

export function toneColor(tone: Tone | undefined): string {
  switch (tone) {
    case "red": return "var(--red)";
    case "yellow": return "var(--yellow)";
    case "green": return "var(--green)";
    case "blue": return "var(--blue)";
    case "purple": return "var(--purple)";
    default: return "var(--ink)";
  }
}

export function toneSoft(tone: Tone | undefined): string {
  switch (tone) {
    case "red": return "var(--red-soft)";
    case "yellow": return "var(--yellow-soft)";
    case "green": return "var(--green-soft)";
    case "blue": return "var(--blue-soft)";
    case "purple": return "#EADDFF";
    default: return "var(--paper-2)";
  }
}
